import { isCurrentAuthSession } from '@/utils/auth-storage-sync.mjs';

export function createTokenChannel(onNewToken, getState) {
  const channel = new BroadcastChannel('auth_channel');

  channel.onmessage = (event) => {
    if (event.data?.type === 'NEW_ACCESS_TOKEN'
      && typeof event.data.token === 'string' && event.data.token
      && isCurrentAuthSession(getState(), event.data.identity, window.localStorage)) {
      onNewToken(event.data.token);
    }
  };

  return channel;
}
